(function(){
  function money(cents){try{return new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(cents/100)}catch(e){return '$'+(cents/100).toFixed(2)}}
  function enhance(cart){
    if(!document.body.classList.contains('template-cart')) return;
    var summary=document.querySelector('.cartSummery .bdr-box');
    if(!summary||summary.dataset.sdEnhanced==='1') return;
    summary.dataset.sdEnhanced='1';

    var title=document.createElement('h2');
    title.className='sd-summary-title';
    title.textContent='Order Summary';
    summary.insertBefore(title,summary.firstChild);

    var qualifies=cart&&cart.total_price>=15000;
    var banner=document.createElement('div');
    banner.className='sd-free-shipping';
    if(qualifies){
      banner.innerHTML='<div class="sd-free-icon">🚚</div><div><strong>You qualify for FREE U.S. SHIPPING!</strong><span>No code needed. Free standard U.S. shipping is applied automatically at checkout.</span></div>';
    }else{
      var remaining=Math.max(0,15000-(cart?cart.total_price:0));
      banner.innerHTML='<div class="sd-free-icon">🚚</div><div><strong>Add '+money(remaining)+' for FREE U.S. SHIPPING</strong><span>Free standard U.S. shipping on merchandise subtotals of $150 or more.</span></div>';
    }
    var subtotal=summary.querySelector('.cart-subtotal-row');
    if(subtotal&&subtotal.nextSibling) summary.insertBefore(banner,subtotal.nextSibling); else summary.insertBefore(banner,summary.firstChild.nextSibling);

    var shippingText=summary.querySelector('.cart__shipping');
    if(shippingText){
      shippingText.innerHTML=qualifies?'<strong>Shipping:</strong> FREE standard U.S. shipping on this qualifying order. Final delivery options and taxes are confirmed at checkout.':'Shipping and taxes are calculated at checkout.';
    }

    var checkout=summary.querySelector('#cartCheckout');
    if(checkout){ checkout.value='Secure Checkout  →'; checkout.setAttribute('aria-label','Secure Checkout'); }

    var express=summary.querySelector('.additional-checkout-buttons');
    if(express){
      var label=document.createElement('div');
      label.className='sd-express-label';
      label.textContent='OR  Express Checkout';
      express.parentNode.insertBefore(label,express);
    }

    var note=document.createElement('div');
    note.className='sd-price-note';
    note.innerHTML='<strong>Pricing details:</strong> merchandise subtotal and any discounts are shown here. Shipping eligibility, delivery options, and applicable taxes are finalized securely at checkout.';
    if(checkout) summary.insertBefore(note,checkout);

    var trust=document.createElement('div');
    trust.className='sd-trust-grid';
    trust.innerHTML='<div class="sd-trust-item"><span class="sd-trust-icon">🚚</span><b>Free U.S. Shipping</b>Orders $150+</div><div class="sd-trust-item"><span class="sd-trust-icon">🔒</span><b>Secure Payments</b>Protected checkout</div><div class="sd-trust-item"><span class="sd-trust-icon">✓</span><b>Authentic Dresses</b>Trusted designers</div><div class="sd-trust-item"><span class="sd-trust-icon">💬</span><b>Need Help?</b>Chat with us</div>';
    summary.appendChild(trust);

    var options=document.querySelectorAll('.cart-options .cart-option');
    options.forEach(function(opt){
      var hasCountry=opt.querySelector('select[name="address[country]"], #address_country, #AddressCountry');
      var txt=(opt.textContent||'').toLowerCase();
      if(hasCountry||txt.indexOf('calculate shipping')>-1||txt.indexOf('shipping estimates')>-1){
        opt.classList.add('sd-cart-option-hidden');
      }
    });
  }
  function run(){
    if(!document.body.classList.contains('template-cart')) return;
    fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json()}).then(enhance).catch(function(){enhance(null)});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run); else run();
})();
